import React, { Component } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { TableListComp, DeletePopUp, EmptyCollection, PageLoader } from '../../../../shared_elements';
import { Header, EditSidebar, ContractHeadertext, CtrTableHd, ContractSideBar, FormModeType } from '../../../../applications/contracts/Elements';
import { WetleaseList } from '../components';
import { ContractWrapper, LeaseDetialTab } from '../../../Elements';
import { STableLoader } from '../../../../shared_elements/loaders';
import { getWetleaseListApi,deleteWetLeaseApi } from '../apiServices';
import { wetleaseHd} from '..';
import { sExportContractsAc } from '../../../actionCreators';
import { assetsType } from '../../../../constants';
import { trackActivity } from '../../../../utils_v2/mixpanel';
import { contrHdlineInfoAc } from '../../../../applications/contracts/HeadlinesInfo/actionCreators';
import { avationPlcInstance, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
import WetleaseCRU from '../components/WetleaseCRU';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import { checkPermission } from '../../../../utils_v2';
import WetleaseCard from '../components/WetleaseCard';
class WetLeases extends Component {
  constructor(props){
    super(props);
    this.state = {
      skeletonLoader: true,
      pageLoader: false,
      list:[],
      deleteItem:{modal:false, data:null}
    }
    this.getWetleaseListApi = getWetleaseListApi.bind(this);
    this.deleteWetLeaseApi = deleteWetLeaseApi.bind(this);
  }
  componentDidMount(){
    this.getWetleaseListApi(this.props);
    this.props.fetchContractInfo();
    trackActivity('Lease Management', {
      page_title: 'WetLease',
      event_type: 'Page Visited'
    })
  }
  
  getResponseBack = () => {
    this.getWetleaseListApi(this.props);
  }
  changeMsn =(evt) =>{
    let url = '/'+assetsType[evt.asset_type]+'/'+evt.slug+'/contracts';
    browserHistory.push(url);
    this.props.params.type = assetsType[evt.asset_type];
    this.props.params.aircraft_slug = evt.slug;
  }
  render(){
    const { list, skeletonLoader, pageLoader, deleteItem } = this.state;
    const { params, contractSummaryLoader, contractInfo } = this.props;
    return(
      <div className="contract-container">
        <Header type="brief" headingText="Lease Management" params= {this.props.params} changeMsn={this.changeMsn} exportContract={this.props.exportContract} />
        <ContractSideBar application="WetLeases" type="brief" params={this.props.params} />
        <div className="contract-content-blk">
          <LeaseDetialTab url='wet-lease' primaryTab='basic-betails' secondaryTab='wetLease' />
          <ContractWrapper
            url='audit/contracts/ctwetlease/'
            queryParams={{action:0, contract:this.props.params.contract_slug}}
            revision={true}
            params={params}
            buttonText={checkPermission('contracts','wet_lease', 'C')?<WetleaseCRU getResponseBack={this.getResponseBack} contractInfo={contractInfo}/>:null}
          >
            { skeletonLoader ?
              (<STableLoader count={5} />):
              (
                <TableListComp
                  height={(avationPlcInstance || titanInstance || mtInstance || leshaBankInstance)?(window.innerHeight - 450) + 'px':''}
                  maxheight={(avationPlcInstance || titanInstance || mtInstance || leshaBankInstance)?(window.innerHeight - 450) + 'px':''}
                  heads={wetleaseHd}
                  data={list.map((item,index) =>
                    <WetleaseList
                      getResponseBack={this.getResponseBack}
                      key={index}
                      item={item} 
                      contractInfo={contractInfo}
                      deleteSubLease={() => this.setState({deleteItem:{modal:true, data:item}})}
                      />
                    )
                  }
                  noRecord={ list.length ? null:
                    <EmptyCollection
                      title="No records found"
                    />
                  }
                />
              )
            }
            { pageLoader || contractSummaryLoader ? <PageLoader />:null}
          </ContractWrapper>
          {(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance) && checkPermission('contracts','wet_lease', 'R') ?
            <WetleaseCard
              props={this.props}
            /> : null}
        </div>
        { deleteItem.modal?
          <DeletePopUp
            modal={deleteItem.modal}
            toggleModalFn={() => this.setState({deleteItem:{modal:false, data:null}})}
            title="Delete"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.deleteWetLeaseApi(this.props,deleteItem)}
          />:null
        }
      </div>
    )
  }
}
const mapStateToProps = state => ({
  contractSummaryLoader: state.contractReducer.contractSummaryLoader,
  contractInfo: state.ContrHdlineReducer.contrHdlineInfo,
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    exportContract : (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
    fetchContractInfo: () => dispatch(contrHdlineInfoAc(ownProps.params)),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(WetLeases,['contracts','wet_lease', 'R'])))
